export const SelectedRangeService = Symbol.for('SelectedRangeService');
